export const DOCUMENT_PARTNER_PROPERTIES_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerPropertiesUpdated";
export const DOCUMENT_PARTNER_PROPERTIES_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerPropertiesInvalidated";
export const ALL_PROPERTIES_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.OfferPropertiesInvalidated";
